(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blend-picker"] && !Shopify.designMode) return;
  try {
    function initBlendPicker(picker) {
      if (picker.dataset.blendInitialized) return;
      picker.dataset.blendInitialized = 'true';

      const form = picker.closest('form');
      const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      const defaultVariantId = variantIdInput ? variantIdInput.value : '';

      const mapScript = picker.querySelector('[data-blend-variant-map]');
      let variantMap = {};
      try {
        variantMap = mapScript ? JSON.parse(mapScript.textContent) : {};
      } catch (e) {
        variantMap = {};
      }

      const checkboxes = Array.from(picker.querySelectorAll('[data-blend-checkbox]'));
      const sizeInputs = Array.from(picker.querySelectorAll('[data-blend-size-input]'));
      const diffuserInputs = Array.from(picker.querySelectorAll('[data-blend-diffuser-input]'));
      const countEl = picker.querySelector('[data-blend-count]');
      const requiredLabels = Array.from(picker.querySelectorAll('[data-blend-required-label]'));
      const errorEl = picker.querySelector('[data-blend-error]');
      const comboErrorEl = picker.querySelector('[data-blend-combo-error]');
      const priceBox = picker.querySelector('[data-blend-price]');
      const priceCurrentEl = picker.querySelector('[data-blend-price-current]');
      const priceCompareEl = picker.querySelector('[data-blend-price-compare]');

      function getRequired() {
        const checkedSize = sizeInputs.find((input) => input.checked);
        return checkedSize ? parseInt(checkedSize.value, 10) : 3;
      }

      function getDiffuser() {
        const checkedDiffuser = diffuserInputs.find((input) => input.checked);
        return checkedDiffuser ? checkedDiffuser.value : null;
      }

      function formatMoney(amount) {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 0,
        }).format(amount);
      }

      function setComboError(message) {
        if (!comboErrorEl) return;
        if (message) {
          comboErrorEl.textContent = message;
          comboErrorEl.hidden = false;
        } else {
          comboErrorEl.textContent = '';
          comboErrorEl.hidden = true;
        }
      }

      function updateState() {
        const required = getRequired();
        picker.dataset.blendRequired = String(required);
        requiredLabels.forEach((label) => {
          label.textContent = String(required);
        });

        const checked = checkboxes.filter((box) => box.checked);

        if (checked.length > required) {
          checked.slice(required).forEach((box) => {
            box.checked = false;
          });
        }

        const activeChecked = checkboxes.filter((box) => box.checked);

        if (countEl) countEl.textContent = String(activeChecked.length);

        checkboxes.forEach((box) => {
          box.disabled = !box.checked && activeChecked.length >= required;
        });

        picker.dataset.blendMatchedVariantId = '';

        const diffuserValue = diffuserInputs.length > 0 ? getDiffuser() : null;
        const oilsComplete = activeChecked.length === required;
        const diffuserComplete = diffuserInputs.length === 0 || Boolean(diffuserValue);

        if (oilsComplete && diffuserComplete) {
          let comboKey = activeChecked.map((box) => box.value).join(' + ');
          if (diffuserValue) comboKey += ' / ' + diffuserValue;
          const match = variantMap[comboKey];

          if (match) {
            setComboError(match.available ? '' : 'This combination is currently sold out. Please choose a different set.');
            picker.dataset.blendMatchedVariantId = match.available ? String(match.id) : '';

            if (variantIdInput) variantIdInput.value = match.id;

            if (priceBox) priceBox.hidden = false;
            if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(match.price);
            if (priceCompareEl) {
              if (match.compareAtPrice && match.compareAtPrice > match.price) {
                priceCompareEl.textContent = formatMoney(match.compareAtPrice);
                priceCompareEl.hidden = false;
              } else {
                priceCompareEl.hidden = true;
              }
            }
          } else {
            if (priceBox) priceBox.hidden = true;
            if (variantIdInput) variantIdInput.value = defaultVariantId;
            setComboError("This combination isn't available yet. Please choose a different set.");
          }
        } else {
          if (priceBox) priceBox.hidden = true;
          if (variantIdInput) variantIdInput.value = defaultVariantId;
          setComboError('');
          if (errorEl && activeChecked.length < required) {
            errorEl.hidden = true;
          }
        }
      }

      checkboxes.forEach((box) => {
        box.addEventListener('change', updateState);
      });

      sizeInputs.forEach((input) => {
        input.addEventListener('change', updateState);
      });

      diffuserInputs.forEach((input) => {
        input.addEventListener('change', updateState);
      });

      updateState();
    }

    document.querySelectorAll('[data-blend-picker]').forEach(initBlendPicker);

    document.addEventListener(
      'submit',
      (event) => {
        const target = event.target;
        if (!target || typeof target.querySelector !== 'function') return;

        const picker = target.querySelector('[data-blend-picker]');
        if (!picker) return;

        const required = parseInt(picker.dataset.blendRequired, 10) || 3;
        const checkedCount = picker.querySelectorAll('[data-blend-checkbox]:checked').length;
        const hasMatchedVariant = Boolean(picker.dataset.blendMatchedVariantId);

        if (checkedCount !== required || !hasMatchedVariant) {
          event.preventDefault();
          event.stopPropagation();

          const errorEl = picker.querySelector('[data-blend-error]');
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      },
      true
    );
  } catch(e) { console.error(e); }
})();

})();
